import DOMPurify from "dompurify";

/**
 * Sanitize HTML string for safe use with dangerouslySetInnerHTML.
 * Use for content from API/backend that may contain formatting (e.g. line breaks).
 * This will not allow any HTML tags or attributes that could be used for XSS attacks (e.g. <script>, <iframe>, <object>), but will allow basic formatting tags like <b>, <i>, <p>, etc.
 */
export const sanitizeHtml = (dirty) => {
  if (dirty == null || typeof dirty !== "string") return { __html: "" };
  return {
    __html: DOMPurify.sanitize(dirty, {
      ALLOWED_TAGS: [
        "b",
        "i",
        "em",
        "strong",
        "u",
        "s",
        "br",
        "p",
        "span",
        "div",
        "ul",
        "ol",
        "li",
        "h1",
        "h2",
        "h3",
        "h4",
        "blockquote",
        "code",
        "pre",
      ],
      // Allow class for layout/styling of trusted modal copy (e.g. non-compliant issue lists)
      ALLOWED_ATTR: ["class"],
    }),
  };
};
